import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { LayoutModule } from './layout/layout.module';
import { AppComponent } from './app.component';

import { environment } from '../environments/environment';
import { ToastrModule } from 'ngx-toastr';
import { httpErrorInterceptor } from './core/interceptors/http-error.interceptor';
import { NoopAuthInterceptor } from './core/interceptors/noop-auth.interceptor';

// MSAL imports
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';
const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

  export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication({
      auth: {
        // 'Application (client) ID' of app registration in Azure portal - this value is a GUID
        clientId: "b7f57e8d-2b99-4f5e-b8e3-d68464c07bf8",
        // Full directory URL, in the form of https://login.microsoftonline.com/<tenant>
        authority: "https://login.microsoftonline.com/db1797ac-34c4-4bfe-88ea-774c8168fe84",
        // Must be the same redirectUri as what was provided in your AD app registration.
        redirectUri: environment.system.adminUiUrl,
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
        storeAuthStateInCookie: isIE
      }
    });
  }

  // MSAL Interceptor is required to request access tokens in order to access the protected resource (Graph)
  export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();
    protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);
    protectedResourceMap.set(environment.api.url, ['https://kov365.onmicrosoft.com/PubShopApi/user_impersonation']);

    return {
      interactionType: InteractionType.Redirect,
      protectedResourceMap
    };
  }

  // MSAL Guard is required to protect routes and require authentication before accessing protected routes
  export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: ['user.read']
      }
    };
  }

  // NgModule that contains the routes and MSAL configurations
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,

    CoreModule,
    LayoutModule,
    ToastrModule.forRoot(),
    MsalModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: environment.auth.disabled ? NoopAuthInterceptor : MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    provideHttpClient(
      withInterceptors([httpErrorInterceptor]),
      withInterceptorsFromDi(),
    )
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }
